import React, { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router'
import { useSelector } from 'react-redux'
import type { MainPage as MainPageData } from 'api/api.types'
import { getSelectedCityId } from 'src/store/app.state.store'
import { Salons } from 'components/PageElements/Salons/Salons'
import { MainMenu } from 'components/PageElements/MainMenu/MainMenu'
import { MainSlides } from './MainSlides'
import styles from './MainPage.module.scss'

/** The fixed header is this tall, so scrolling to services stops below it */
const HEADER_HEIGHT = 60
/** Element ids, also scrolled to from the #services and #salons links */
const SERVICES_ID = 'serivces-list'
const SALONS_ID = 'salons-list'

type MainPageProps = {
  page: MainPageData,
}

export const MainPage: React.FC<MainPageProps> = React.memo(({ page }) => {
  const slides = page.templateVars.pageVars.slides
  const location = useLocation()
  const activeCityId = useSelector(getSelectedCityId)

  useEffect(() => {
    if (location.hash === '#services') {
      const servicesList = document.getElementById(SERVICES_ID)
      if (servicesList) {
        window.scrollTo(0, servicesList.offsetTop - HEADER_HEIGHT)
        return
      }
    }
    if (location.hash === '#salons') {
      const salonsList = document.getElementById(SALONS_ID)
      if (salonsList) {
        window.scrollTo(0, salonsList.offsetTop)
        return
      }
    }
    document.documentElement.scrollTop = 0
  }, [location.hash])

  const citySlides = useMemo(
    () => slides.filter((slide) => activeCityId !== null && slide.cities.includes(activeCityId)),
    [activeCityId, slides],
  )

  return (
    <div className={styles.container}>
      <MainSlides slides={citySlides} />
      <div id={SERVICES_ID} className={styles.servicesList}>
        <MainMenu />
      </div>
      <div id={SALONS_ID} className={styles.salonsList}>
        <Salons withCityTitle />
      </div>
    </div>
  )
})
MainPage.displayName = 'MainPage'
